const { ajaxHandler, isMobileDevice } = require("./utilities/utilities");


document.addEventListener('DOMContentLoaded', function () {
    /**
     * vendora user login.
     *
     * @since 1.0.0
     */
    const loginForm = document.getElementById('vendora-login');
    const loginError = document.querySelector('.vendora-login-error');

    if (loginForm) {

        /**
         * Manage redirect URL
         */
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirect');
        const redirectInput = document.querySelector('input[name="redirect"]')

        if (redirectInput) {
            redirectInput.value = redirectUrl
        }

        loginForm.addEventListener('submit', async (e) => {
            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.vendora-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]');

            if (!loginForm.checkValidity()) {
                e.preventDefault();
                return loginForm.classList.add("vendora-was-validated");
            }

            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('vendora-d-none');
            spinnerText.innerHTML = 'Processing...'

        });
    }

    /**
     * vendora user register.
     *
     * @since 1.0.0
     */
    const registerForm = document.getElementById('vendora-register');
    const registerError = document.querySelector('.vendora-register-error');
    const registerSuccess = document.querySelector('.vendora-register-success');

    if (registerForm) {
        registerForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.vendora-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;

            if (!registerForm.checkValidity()) {
                return registerForm.classList.add('vendora-was-validated');
            }

            const formData = new FormData(registerForm);

            registerError.classList.add('vendora-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('vendora-d-none');
            spinnerText.innerHTML = 'Processing...'

            const res = await ajaxHandler(formData);
            const { success, message } = res;

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText
            spinner.classList.add('vendora-d-none');

            if (success) {
                registerForm.classList.remove('vendora-was-validated');
                registerForm.reset();
                btnSubmit.setAttribute('disabled', '');

                registerSuccess.innerHTML = message;
                registerSuccess.classList.remove('vendora-d-none');
            } else {
                registerError.classList.remove('vendora-d-none');
                registerError.innerHTML = message;
            }

        });
    }

    /**
     * vendora forgot password
     *
     * @since 1.0.0
     */
    const forgotPasswordForm = document.getElementById('vendora-forgot-password');
    const forgotPasswordError = document.querySelector('.vendora-forgot-password-error');
    const forgotPasswordSuccess = document.querySelector('.vendora-forgot-password-success');

    if (forgotPasswordForm) {
        forgotPasswordForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.vendora-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;


            if (!forgotPasswordForm.checkValidity()) {
                return forgotPasswordForm.classList.add("vendora-was-validated");
            }

            forgotPasswordError.classList.add('vendora-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('vendora-d-none');
            spinnerText.innerHTML = 'Processing...'

            const formData = new FormData(forgotPasswordForm);

            const res = await ajaxHandler(formData);

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText
            spinner.classList.add('vendora-d-none');

            const { success, message } = res;
            if (success) {
                forgotPasswordForm.reset();

                btnSubmit.setAttribute('disabled', '');
                forgotPasswordSuccess.classList.remove('vendora-d-none')
                forgotPasswordSuccess.innerHTML = message
            } else {
                forgotPasswordError.classList.remove('vendora-d-none')
                forgotPasswordError.innerHTML = message;
            }
        });
    }

    /**
     * vendora reset password
     *
     * @since 1.0.0
     */
    const resetPasswordForm = document.getElementById('vendora-reset-password');
    const resetPasswordError = document.querySelector('.vendora-reset-password-error');
    const resetPasswordSuccess = document.querySelector('.vendora-reset-password-success');

    if (resetPasswordForm) {
        resetPasswordForm.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btnSubmit = e.target.querySelector('button[type="submit"]'),
                spinner = btnSubmit.querySelector('.vendora-spinner-border'),
                spinnerText = btnSubmit.querySelector('span[role=status]'),
                oldText = spinnerText.innerHTML;


            if (!resetPasswordForm.checkValidity()) {
                return resetPasswordForm.classList.add("vendora-was-validated");
            }

            resetPasswordError.classList.add('vendora-d-none');
            btnSubmit.setAttribute('disabled', 'disabled');
            spinner.classList.remove('vendora-d-none');
            spinnerText.innerHTML = 'Processing...'

            const formData = new FormData(resetPasswordForm);

            const res = await ajaxHandler(formData);

            btnSubmit.removeAttribute('disabled');
            spinnerText.innerHTML = oldText;
            spinner.classList.add('vendora-d-none');

            const { success, message } = res;
            if (success) {
                resetPasswordForm.reset();

                btnSubmit.setAttribute('disabled', '');
                window.location.href = `${message.redirect_url}?password-reset=true`;
            } else {
                resetPasswordError.classList.remove('vendora-d-none');
                resetPasswordError.innerHTML = message;
            }
        });
    }

    // Remove classes for smaller devices
    if (isMobileDevice() && (loginForm || registerForm)) {
        const inputs = document.querySelectorAll('input.vendora-form-control-lg');
        const labels = document.querySelectorAll('label.vendora-form-label.vendora-fs-4');

        labels.forEach(function (label) {
            label.classList.remove('vendora-fs-4');
        });

        inputs.forEach(function (input) {
            input.classList.remove('vendora-form-control-lg');
        });
    }
})
